import { call, put, takeEvery, select } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { AuthSequence } from "../Sequences/AuthSequence";
import { browserHistory } from "react-router";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { UserSettingsInterface } from "../../Entity/Entities/Settings/User/UserSettingsInterface";
import Auth from "../../Auth/Auth";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import UserSettingsFactory from "../../Entity/Factories/UserSettingsFactory";
import TokenActions from "../../Action/Actions/TokenActions";
import ConfirmActions from "../../Action/Actions/ConfirmActions";
import UserActions from "../../Action/Actions/UserActions";
import Token from "../../Token/Token";

export default function* signin(action: ActionInterface): any {
  try {
    const res = yield call(Auth.signin, action.payload?.id, action.payload?.password, action.payload?.agencyId, action.payload?.email);
    const user: PersonInterface = PersonFactory.create(res);
    const settings: UserSettingsInterface = UserSettingsFactory.create(res.userSettings[0]);
    const redirectPathAfterAuth: string = yield select((state: any) => state.app.redirectPathAfterAuth);

    // should apply user settings
    yield put(UserActions.auth(user, settings));
    // should update token in storage
    yield put(TokenActions.update(res.token));
    // not sure why do we need this confirm action
    yield put(ConfirmActions.signinSuccess(user));

    yield AuthSequence();

    yield put({
      type: Constants.PAGE_CHECK_VERSION_START
    });

    const token: string = yield call(Token.get);

    // we should redirect user to correct page
    // if no token, redirect to login page
    if (!token) {
      if (action.hasOwnProperty("onSuccess")) {
        action.onSuccess.call(this, false);
      }

      return yield put({
        type: Constants.PAGE_SIGNOUT_START
      });
    } else {
      // CASA-7867
      yield put({
        type: Constants.SNACKBAR_CLEAR_MESSAGES
      });

      // if no redirectPathAfterAuth, redirect to unit list else redirect to redirectPathAfterAuth
      if (redirectPathAfterAuth.startsWith("/auth")) {
        if (token) {
          browserHistory.push("http://localhost:4040/app/dashboard/overview");
        } else {
          return yield put({
            type: Constants.PAGE_SIGNOUT_START
          });
        }
      } else {
        browserHistory.push(redirectPathAfterAuth);
      }
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
    yield put(ConfirmActions.signinFailure(err));
    yield put(ConfirmActions.openPopup(err.translatedMessage));
  }
}

export function* watchSignIn() {
  yield takeEvery(Constants.PAGE_CONFIRM_SIGNIN, signin);
}
